module.exports = __webpack_public_path__ + "static/WWantsome_Logo_Light1_03.5bef9e43.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/WWantsome_Logo_Light1_03.png
// module id = 575
// module chunks = 65310338191660